document.addEventListener('DOMContentLoaded', function () {

    let videoIndex = document.querySelector('.custom-swiper-slide')?.getAttribute('data-no');
    videoIndex = parseInt(videoIndex);
  
    // Initialize mobile gallery Swipix
    window.newPDPimgSwipix = new Swipix({
      container: '.custom-swipix-container-pdp-img--mobile',
      nextButton: '.custom-right-arrow-pdp',
      prevButton: '.custom-left-arrow-pdp',
      slidesPerView: { default: 1 },
      lazyMedia: true,
      loop: true,
      // gap: 1,
      autoplay: {
        enabled: false,
        delay: 5000,               
        pauseOnInteraction: false,  
        pauseAfterInteraction: false 
      },
      tabsConfig: {
        container: '.custom-swiper-container',
        buttonSelector: '.custom-swiper-slide',
        mapping: [videoIndex, videoIndex+1, videoIndex+2, videoIndex+3, videoIndex+4, videoIndex+5, videoIndex+6, videoIndex+7, videoIndex+8, videoIndex+9, videoIndex+10], 
        activeClass: 'activefeat'
      }
    }).init();
  
    // Initialize desktop gallery Swipix
    window.newPDPimgSwipixDesktop = new Swipix({
      container: '.custom-swipix-container-pdp-img--desktop',
      nextButton: '.custom-right-arrow-pdp',
      prevButton: '.custom-left-arrow-pdp',
      slidesPerView: { default: 1 },
      lazyMedia: true,
      loop: true,
      autoplay: {
        enabled: false,
        delay: 5000,
        pauseOnInteraction: false,
        pauseAfterInteraction: false
      },
      tabsConfig: {
        container: '.custom-swiper-container',
        buttonSelector: '.custom-swiper-slide',
        mapping: [videoIndex, videoIndex+1, videoIndex+2, videoIndex+3, videoIndex+4, videoIndex+5, videoIndex+6, videoIndex+7, videoIndex+8, videoIndex+9, videoIndex+10], 
        activeClass: 'activefeat'
      }
    }).init();
  
    const pdpNumberEle = document.querySelector('.current_slide_count-new');
    const visitedSlides = [1];
  
    document.addEventListener('swipix:slideChanged', (e) => {
      if(
        e.detail.carousel.config.container == '.custom-swipix-container-pdp-img--mobile' ||
        e.detail.carousel.config.container == '.custom-swipix-container-pdp-img--desktop'
      ){
        const currentSlide = e.detail.currentIndex + 1;
        pdpNumberEle.textContent = currentSlide;
  
        if (!visitedSlides.includes(currentSlide)) {
          // Fire GA event (replace this with your GA event code)
          gaEvent('pdp_img', [currentSlide, '', '', '', '', ''], false);
          
          // Add the current slide index to the visited array
          visitedSlides.push(currentSlide);
        }
      } 
    });
  });
  
  const qtyInput = document.querySelector('.dev_npdp_qty');
        
  // Get the plus and minus buttons
  const plusButton = document.querySelector('.dev_qty_plus');
  const minusButton = document.querySelector('.dev_qty_minus');
  
  // Function to update the quantity
  function updateQty(increment) {
    let currentQty = parseInt(qtyInput.value) || 1; // Parse the current value to an integer
    currentQty += increment; // Update the quantity
    currentQty = Math.max(currentQty, 1); // Ensure the quantity is not negative
    qtyInput.value = currentQty; // Set the updated quantity back to the input box
  }
  
  // Event listener for the plus button
  plusButton.addEventListener('click', () => {
    updateQty(1);
    $(document).find('.dev_atc_form').attr('data-quantity', qtyInput.value);
  });
  
  // Event listener for the minus button
  minusButton.addEventListener('click', () => {
    updateQty(-1); 
    $(document).find('.dev_atc_form').attr('data-quantity', qtyInput.value);
  });
  
  qtyInput.addEventListener('input', function (e) {
    qtyInput.value = qtyInput?.value.replace(/\D+/g, '');
    let value = parseInt(e.target.value);
    if (isNaN(value) || value < 1) {
      value = 1; 
    }
    // qtyInput.value = value;
    $(document).find('.dev_atc_form').attr('data-quantity', qtyInput.value);
  });
  
  document.addEventListener("DOMContentLoaded", () => {
    const startTimer = (duration, displays) => {
      const endTime = Date.now() + duration * 1000;
      const intervalId = setInterval(() => {
        // Calculate the remaining time in seconds
        const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
        const days = Math.floor(remaining / (24 * 3600));
        const hours = Math.floor((remaining % (24 * 3600)) / 3600);
        let minutes = Math.floor((remaining % 3600) / 60);
        let seconds = remaining % 60;
        
        // Format minutes and seconds
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        
        // Prepare the display text
        const displayText = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        
        // Update all display elements
        displays.forEach(display => {
          display.textContent = displayText;
        });
        
        // Clear the interval if the countdown has finished
        if (remaining <= 0) {
          clearInterval(intervalId);
        }
      }, 1000);
    };
  
    // Get the offer end date and calculate the duration in seconds
    const offerEndDate = new Date(window.newPDPTimerDate).getTime();
    const now = Date.now();
    const duration = Math.floor((offerEndDate - now) / 1000);
  
    // Get display elements and convert HTMLCollection to an array
    const displays = Array.from(document.getElementsByClassName("offer-time-new"));
  
    // Start the timer if there is at least one display element and the duration is positive
    if (displays.length > 0 && duration > 0) {
      startTimer(duration, displays);
    }
  });
  
  // Timer end
  $(document).ready(function(){
        
    $(document).find('.dev_show_images_after_slick_load').css({ position: "", top: "", visibility: "" });
    $(document).find('.dev_hide_images_after_slick_load').hide();
  
    $(document).on('click', ".dev_features_icon", function(){
       /* FEATURE ICON GA4 EVENT */
         if (typeof dataLayer !== 'undefined') {
            gaEvent('feature_highlight', [$(this).data('position'), $(this).data('feature'), '', '', '', ''], false);
          }         
      });
  });
  
  var buyxgetY= false;
    document.addEventListener("DOMContentLoaded", function() {
      var coupn_txt = window.newPdpCouponName;
      var coupn_total_discount_amount = window.newPdpCouponDiscount;
  
      
      // Parse the variant data from the JSON script tag
      const productData = JSON.parse(document.getElementById('product-data').textContent);
      const variants = productData.variants;
      // Function to find the variant ID based on selected options
      function getSelectedVariantId() {
        // Collect selected options
        let selectedOptions = [];
        document.querySelectorAll('.variant-option').forEach(function(optionWrapper) {
          const selectedRadio = optionWrapper.querySelector('input[type="radio"]:checked');
          if (selectedRadio) {
            selectedOptions.push(selectedRadio.value);
          }
        });

        // Find the matching variant ID
        let selectedVariantId = null;
        let selectedVariantPrice = null;
        let selectedVariantCompPrice = null;
        let discount = 0;
        let featureimage = "";
        let variantisavailable = null;
        let desktopImage = ""; // new: desktop specific image
        variants.forEach(function(variant) {
        console.log("slcted variant ==> ", variant);
          if (JSON.stringify(variant.options) === JSON.stringify(selectedOptions)) {
            selectedVariantId = variant.id;
            selectedVariantPrice = variant.price;
            selectedVariantCompPrice = variant.compare_at_price;
  
            var price_difference = variant.normal_compare_at_price - variant.normal_price;
            var discount_percentage = (price_difference * 100.0) / variant.normal_compare_at_price;
            discount = Math.round(discount_percentage);
            featureimage = variant.featureimage;
            variantisavailable = variant.variant_isavailable;
            // Try to resolve desktop image from multiple possible shapes
            try {
              desktopImage = (variant.desktop_image)
                || (variant.metafields && variant.metafields.custom && (variant.metafields.custom.desktop_image?.value || variant.metafields.custom.desktop_image))
                || "";
            } catch(e) { desktopImage = ""; }

            if(variantisavailable == true){
              document.querySelector(".np-qty-atc .product-form").style.display = "block";
              document.querySelector(".np-qty-atc button.add-to-cart-button.dev_e_atc_top").style.display = "block";
              document.querySelector("#notify-btn").style.display = "none";
              document.querySelector(".out_of_stock_card").style.display = "none";
              document.body.classList.add('variant_instock');
              // setTimeout(function () {
              //  // document.querySelector(".custom-pincode-container .estimate-widget").style.display = "block";
              // }, 2000);
              console.log('in__stock');
            }else{
              document.querySelector(".np-qty-atc .product-form").style.display = "none";
              document.querySelector("#notify-btn").style.display = "flex";
              document.querySelector(".out_of_stock_card").style.display = "block";
              document.body.classList.remove('variant_instock');
              // setTimeout(function () {
              // //  document.querySelector(".custom-pincode-container .estimate-widget").style.display = "none";
              // }, 2000);
            }
          }

          // For AeroPlus Adjustable Desk size changes
            // Find the matching variant
          setTimeout(function() {
           if ((window.location.href.includes('/products/adjustable-desk') || window.location.href.includes('/products/aeropro-adjustable-desk')) && window.innerWidth > 768) {
               // For AeroPlus Adjustable Desk size changes
            // Find the matching variant
                  const matchedVariant = variants.find(v => 
                    JSON.stringify(v.options) === JSON.stringify(selectedOptions)
                  );
                  if (matchedVariant) {
                    const activeSlideImg = document.querySelector('.pix-slide.chair-pdp-img-slide.swipix-slide-active img');
                    if (activeSlideImg && desktopImage) {
                      activeSlideImg.src = desktopImage;
                    }
                  }
             }
             }, 500);

            if ((window.location.href.includes('/products/adjustable-desk') || window.location.href.includes('/products/aeropro-adjustable-desk')) && window.innerWidth < 768) {
              document.querySelectorAll('input[name="option-Sizes"]').forEach(sizeInput => {
                sizeInput.addEventListener('change', function () {

                  // Recalculate selected options fresh on every change
                  let selectedOptions = [];
                  document.querySelectorAll('.variant-option').forEach(optionWrapper => {
                    const selectedRadio = optionWrapper.querySelector('input[type="radio"]:checked');
                    if (selectedRadio) {
                      selectedOptions.push(selectedRadio.value);
                    }
                  });

                  // Find matching variant
                  const matchedVariant = variants.find(v =>
                    JSON.stringify(v.options) === JSON.stringify(selectedOptions)
                  );

                  if (matchedVariant) {
                      // Select correct image based on device
                      const imageToUse =
                        window.innerWidth <= 768
                          ? matchedVariant.featureimage // mobile
                          : matchedVariant.desktop_image ||
                            matchedVariant?.metafields?.custom?.desktop_image?.value ||
                            ""; // desktop

                      const activeSlideImg = document.querySelector(
                        '.pix-slide.chair-pdp-img-slide.swipix-slide-active img'
                      );

                      if (activeSlideImg && imageToUse) {
                        activeSlideImg.src = imageToUse;
                        console.log(
                          `✅ Updated image for ${window.innerWidth <= 768 ? "mobile" : "desktop"} size:`,
                          selectedOptions.join(", ")
                        );
                        window.scrollTo({
                          top: 0,
                          behavior: 'smooth'
                        });
                      }
                    }
                });
              });
            }

          

        });
        return selectedVariantId+"----"+selectedVariantPrice+"----"+selectedVariantCompPrice+"----"+discount+"----"+featureimage+"----"+variantisavailable+"----"+desktopImage;
      }
  
      let v_id_p = getSelectedVariantId();
      v_id_p = v_id_p.split('----');
      // Decide which image to use based on device: mobile -> existing featureimage, desktop -> metafield desktop_image (fallback to featureimage)
      (function(){
        const isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
        const mobileImageUrl = v_id_p[4];
        const desktopImageUrl = v_id_p[6] && v_id_p[6].length ? v_id_p[6] : v_id_p[4];
        const chosenUrl = isMobile ? mobileImageUrl : desktopImageUrl;
        getSlideIndexFromImageUrl(chosenUrl);
      })();
  
      // Attach change event listeners to radio buttons
      document.querySelectorAll('.dev_npdp_variant_change').forEach(function(radio) {
        radio.addEventListener('change', function() {
          let v_id_p = getSelectedVariantId();
          console.log("v_id_p ==> ", v_id_p);
          console.log("radio==>3 ", radio);
          v_id_p = v_id_p.split('----');
          // Decide which image to use based on device on variant change
          (function(){
            const isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
            const mobileImageUrl = v_id_p[4];
            const desktopImageUrl = v_id_p[6] && v_id_p[6].length ? v_id_p[6] : v_id_p[4];
            const chosenUrl = isMobile ? mobileImageUrl : desktopImageUrl;
            getSlideIndexFromImageUrl(chosenUrl);
          })();
          $(document).find('.dev_variant_id').val(""+v_id_p[0]+"");
          if (v_id_p[5] == "true"){
            $(document).find('.dev_product-variant-availability-check #add-to-cart-button').html(`Add to cart <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 4L11.09 5.41L16.67 11H4.5V13H16.67L11.09 18.59L12.5 20L20.5 12L12.5 4Z" fill="white"></path></svg>`);
            $(document).find('.dev_product-variant-availability-check').attr('disabled', false);
            document.querySelector(".np-qty-atc .product-form").style.display = "block";
            document.querySelector(".np-qty-atc button.add-to-cart-button.dev_e_atc_top").style.display = "block";
            document.querySelector("#notify-btn").style.display = "none";
            document.querySelector(".out_of_stock_card").style.display = "none";
            console.log('in__stock');
          } else {
            $(document).find('.dev_product-variant-availability-check #add-to-cart-button').text("Sold Out");
            $(document).find('.dev_product-variant-availability-check').attr('disabled', true);
            document.querySelector(".np-qty-atc .product-form").style.display = "none";
            document.querySelector("#notify-btn").style.display = "flex";
            document.querySelector(".out_of_stock_card").style.display = "block";
            console.log('out__stock');
          }
          $(document).find('.dev_variant_price').text(""+v_id_p[1]+"");
          $(document).find('.dev_edithtml_discount_strip .chair-price').text("₹"+formatToIndianNumberingSystem(parseFloat(v_id_p[1].replace(/[^0-9.-]+/g, '')) - coupn_total_discount_amount));
          $(document).find('.dev_edithtml_discount_strip .chair-coupen').text(coupn_txt);
          $(document).find('.dev_variant_comp_price').text(""+v_id_p[2]+"");
          $(document).find('.dev_discount_per').text(v_id_p[3]+"% off ");
          product_data['variant_id'] = v_id_p[0];
          $(document).find('.dev_edd_variant_id').val(v_id_p[0]);
          $(document).find('.dev_atc_form').attr('data-variant-id', v_id_p[0]);
          
          
          runBundleScript(v_id_p[0]);
          
          setTimeout(function(){
              if ($('.dev_edd_content').is(':visible')) {
                if($(document).find('.dev_pincode').val() != "")
                    $(document).find('.dev_npdp_checkpincode').trigger("click");  
              }
            }, 1000);
          updateURL(v_id_p[0]);
        });
      });
      
      function formatToIndianNumberingSystem(number) {
      return Math.round(number)
          .toString() 
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",") 
          .replace(/(\d+),(\d{2})(?!\d)/, "$1,$2");
      }
  
      $(document).on('change', '.dev_npdp_variant_change', function(){
        // get selected variant details recliner sofa
        const itemsTohide = document.querySelectorAll('.recliner-sofa-pdp-js-rotates-up-to-270');
        if(itemsTohide.length > 0) {
          const selectedVariantVal = $(this).val().toLowerCase();
          if(selectedVariantVal == 'revolving'){
            itemsTohide.forEach(item => {
              item.style.removeProperty('display'); 
            });
          } else if(selectedVariantVal == 'non-revolving'){
            itemsTohide.forEach(item => {
              item.style.display = 'none';
            });
          }
        }
        // end recliner sofa icon toggle
          $(this).parent('.npdp-variant-options').find('.npdp-radio-label').removeClass('selected-radio');
          $(this).next('.npdp-radio-label').addClass('selected-radio');
        $(this).parents('.dev_parent_to_change_variant_name').find('.v2_selected_variant').text($(this).data('select_value'));

        // Toggle model note (e.g. Choose Model: Standard/Premium). No-op unless
        // this option group actually has a note wrapper, so it never affects
        // other products/options sharing this template.
        var $modelNoteWrapper = $(this).parents('.dev_parent_to_change_variant_name').find('.npdp-model-note-wrapper');
        if ($modelNoteWrapper.length) {
          var selectedModelValue = $(this).attr('data-select_value');
          $modelNoteWrapper.find('.npdp-model-note').each(function () {
            $(this).toggle($(this).attr('data-model-note') === selectedModelValue);
          });
        }
        
        // Show video on color change for desktop view if metafield have custom video in variant.
        const inputSourceId = this.getAttribute('data-variant-source-id');
        if(inputSourceId != null && inputSourceId !== undefined){
            if(window.innerWidth > 767){
              const sliderMainMedias = document.querySelectorAll('.custom-swipix-container-pdp-img--desktop .pix-slide');
              const thumsDesktop = document.querySelectorAll('.desktop-thumbnail-container .custom-thumbnail-slide');
                thumsDesktop.forEach(thumb => {
                  if(thumb.getAttribute('data-slide-id') === inputSourceId){
                    let slideIndex = parseInt(thumb.getAttribute('data-slide-index'));
                      window.newPDPimgSwipixDesktop.slideTo(slideIndex);
                      const interval = setInterval(() => {
                        window.newPDPimgSwipixDesktop.slideTo(slideIndex);
                        goToMainSlide(slideIndex, 'desktop');

                        sliderMainMedias.forEach(media => {
                            if(media.getAttribute('data-swipix-index') == slideIndex){ 
                              media.style.visibility = 'visible';
                            } else {
                              media.style.visibility = 'hidden';
                            }
                        });

                      }, 0);
                      setTimeout(() => {
                        clearInterval(interval);
                          sliderMainMedias.forEach(media => {
                            media.style.visibility = 'visible';
                          });
                      }, 400);
                    }
                });
            }
          }
        //
      });
    });
  
    $(document).ready(function() { 
      runBundleScript(window.newPDPFirstProductId);
      $(document).find('.dev_npdp_variant_change').prop("disabled", false);
    });
  
  $(document).ready(function () {
    const popupPincode = localStorage.getItem('popupPincode');
    if (popupPincode) {
      $(document).find(".dev_pincode").val(popupPincode);
      setTimeout(function () {
        $(document).find('.dev_npdp_checkpincode').trigger("click");
      }, 1000); // 1-second delay
    }
   });
  
   const newpslider = document.querySelector('.offer-slider');
   let isDown = false;
   let startX;
   let scrollLeft;
   
   newpslider?.addEventListener('mousedown', (e) => {
       isDown = true;
       newpslider.classList.add('active');
       startX = e.pageX - newpslider.offsetLeft;
       scrollLeft = newpslider.scrollLeft;
   });
   
   newpslider?.addEventListener('mouseleave', () => {
       isDown = false;
       newpslider.classList.remove('active');
   });
   
   newpslider?.addEventListener('mouseup', () => {
       isDown = false;
       newpslider.classList.remove('active');
   });
   
   newpslider?.addEventListener('mousemove', (e) => {
       if (!isDown) return;
       e.preventDefault();
       const x = e.pageX - newpslider.offsetLeft;
       const walk = (x - startX) * 2; 
       newpslider.scrollLeft = scrollLeft - walk;
   });
  
  // $(document).on('click', '.shop-button-wrapper', function() {
  //  dataLayer.push({ custom: null }); 
  //  dataLayer.push({
  //      event: "video_call_popin",
  //      custom: {
  //          param_1: "product_page",  
  //          param_2: "", 
  //          param_3: "",	
  //          param_4: "",
  //          param_5: "",
  //          param_6: ""
  //      }
  //  });
  
  // });
  
  $(document).on('click', '#locate_str_btnnn', function() {
   gaEvent('store_visit', ["product_page", "https://api.whatsapp.com/send/?phone=919152131284&text=Please+share+the+nearest+store&type=phone_number&app_absent=0", "", "", "", ""], false);
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    const slidesForView = window.innerWidth >= 1024 ? 6 : 4;
    new Swipix({
      container: '.custom-swiper-container',
      nextButton: '.custom-right-arrow',
      prevButton: '.custom-left-arrow',
      slidesPerView: {
        default: slidesForView, 
      },
    }).init();
  });
  
  $(document).ready(function() {
    $('.dev_full_screen_icon').on('click', function() {
      if( $('.slick-active .dev_image_full_screen').hasClass('slide-video')){
        window.open($('.slick-active .dev_image_full_screen').attr('href'));
      }else{
        $('.slick-active .dev_image_full_screen').trigger('click');
      }
        
      // $('.content-14').trigger('click');
    });
  
  document.querySelectorAll('.npdp-radio-label').forEach(label => {
      label.addEventListener('click', function() {
        document.getElementById('npdp-main-sns').scrollIntoView({ behavior: 'smooth' });
      });
    });
  });
  
  // Whishlist script
  function setCookie(name, value, minutes) {
    let expires = "";
    if (minutes) {
        let date = new Date();
        date.setTime(date.getTime() + minutes * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + JSON.stringify(value) + expires + "; path=/";
  } 
  
  function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(c.substring(nameEQ.length, c.length));
        } catch (e) {
          console.error("Error parsing cookie:", name, e);
          return null;
        }
      }
    }
    return null;
  }
  
  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
  
  $(document).ready(function () {
    let wishlistSynced = getCookie('wishlist_synced');
  
    if (wishlistSynced && wishlistSynced.productId === window.productDetails.id) {
      $("#pdpwishlist svg circle").css("fill", "#1a2b58");
      $("#pdpwishlist svg path").css("fill", "#FFF");
      deleteCookie('wishlist_synced');
    }
  });

   function setWishlistHeartFilled() {
  $('#pdpwishlist svg').css('fill', '#1A2B58');
  $('.add_to_wishlist').removeClass('add_to_wishlist').addClass('remove_from_wishlist');
}

function setWishlistHeartEmpty() {
  $('#pdpwishlist svg').css('fill', '#FFFFFF');
  $('.remove_from_wishlist').removeClass('remove_from_wishlist').addClass('add_to_wishlist');
}

/* ---------- datafeed API call (LeadSquared / WebEngage) ---------- */

/**
 * /lead/datafeed is a LEAD-capture endpoint (feeds LeadSquared + WebEngage), not a
 * wishlist-data endpoint. This payload shape is copied from a call to this same
 * endpoint that is already working elsewhere in your theme (wishlist_login_popup
 * section), so the field names below are confirmed-correct, not a guess.
 *
 * window.userData currently exposes: isLoggedIn (customer id), phone, email.
 * It does NOT expose a name field yet — user_name will be sent as an empty string
 * until that's added to window.userData. If a blank user_name causes lead-creation
 * to fail on your CRM side, that field needs to be added to window.userData by
 * whoever sets that variable (probably a Liquid snippet using {{ customer.name }}).
 */
function buildDatafeedPayload(requestData) {
  const userName = (window.userData && window.userData.name) || '';
  const userEmail = (window.userData && window.userData.email) || '';
  const userPhone = (window.userData && window.userData.phone) || '';

  const productType = requestData.productType || '';
  const productName = (window.productDetails && window.productDetails.titleJson) || '';
  const variantId = requestData.variantId || '';

  const primaryProductCategory = window.getPrimaryProductCategory
    ? window.getPrimaryProductCategory(
        productType,
        productName,
        (window.productDetails && window.productDetails.collectionHandle) || '',
        requestData.productId
      )
    : '';

  return {
    user_name: userName,
    user_email: userEmail,
    phone: userPhone,
    source: 'Wishlist',
    activity_source: 'Wishlist',
    product_type: productType,
    product_name: productName,
    lead_status: 'Tier 1',
    mx_custom_3: productType,
    mx_custom_6: productName,
    mx_custom_9: productName,
    variant_id: variantId,
    mx_Primary_Product_Category: primaryProductCategory,
    mx_mobile_device: getDeviceModel(),
    mx_mobile_os: getOSWithVersion(),
    is_web_engage_event: true,
    web_engage_data: {
      product_category: productType,
      product_subcategory: productName,
      variant_id: variantId
    }
  };
}

function sendToDatafeed(requestData) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const raw = JSON.stringify(buildDatafeedPayload(requestData));

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch('https://apis.thesleepcompany.in/lead/datafeed', requestOptions)
    .then(response => response.text())
    .then(result => console.log('Datafeed response:', result))
    .catch(error => console.error('Datafeed API Error:', error));
}

/* ---------- On page load: restore heart state from the real wishlist API ---------- */
/*
   The old cookie/localStorage approach only ever reflected "did I just click this
   button", not "is this product actually in my wishlist". The correct fix (matching
   how it's done elsewhere on the site) is to GET the customer's real wishlist and
   check whether this product is in it — that's what stays accurate across refreshes,
   devices, and sessions.
*/
$(document).ready(function () {
  if (!window.userData || !window.userData.isLoggedIn || !window.productDetails) {
    return; // guest / no product context — nothing to check server-side
  }

  const userId = window.userData.isLoggedIn.toString();
  const productId = window.productDetails.id.toString();
  const getUrl = `https://ux6g55bd4a.execute-api.ap-south-1.amazonaws.com/prod/wishlist/${userId}`;
  const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';

  fetch(getUrl, {
    method: 'GET',
    headers: { 'x-api-key': apiKey }
  })
    .then(response => response.json())
    .then(data => {
      const isWishlisted = data.wishlist && data.wishlist.some(p => p.productId == productId);
      if (isWishlisted) {
        setWishlistHeartFilled();
      }
    })
    .catch(error => console.error('Wishlist status check failed:', error));
});

$(document).on('click', '.add_to_wishlist', function () {
  const pageVariantId = new URLSearchParams(window.location.search).get('variant') || '';

  if (window.userData && window.userData.isLoggedIn) {
    const apiUrl = `https://ux6g55bd4a.execute-api.ap-south-1.amazonaws.com/prod/wishlist`;
    const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';

    const requestData = {
      userId: window.userData.isLoggedIn.toString(),
      productId: window.productDetails.id.toString(),
      productUrl: window.productDetails.handle.toString(),
      productType: window.productDetails.type.toString(),
      productAvailability: window.productDetails.available.toString(),
      productPrice: window.productDetails.price.toString(),
      variantId: pageVariantId,
      action: 'ADD_TO_WISHLIST',
    };

    // Fire the lead/datafeed call alongside the wishlist call
    sendToDatafeed(requestData);

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success === true) {
          setWishlistHeartFilled();

          var wishlistNotification = '<div id="prod_wishlisted" class="centered-container" style="z-index: 9;position: fixed;bottom: 10%;left: 50%;transform: translateX(-50%);border-radius: 20px;background-color: #1a2b58;width: 270px;height: 40px;display: flex;color: white;align-items: center;justify-content: center">' +
            '<p>Product is wishlisted!</p>' +
          '</div>';

          $('body').append(wishlistNotification);
          setTimeout(function () {
            $('body #prod_wishlisted').remove();
          }, 2000);
        }
      })
      .catch(error => console.error('Wishlist API Error:', error));

  } else {
    // Not logged in: match the site's existing pattern — stash the pending product
    // id and send the user to log in; the theme's post-login script (see
    // wishlist_login_popup section) re-checks 'wishlist-product' from localStorage
    // and completes the ADD_TO_WISHLIST + datafeed calls after login.
    localStorage.setItem('wishlist-product', window.productDetails.id);
    window.location.href = '/account/login';
  }
});

$(document).on('click', '.remove_from_wishlist', function () {
  const apiUrl = `https://ux6g55bd4a.execute-api.ap-south-1.amazonaws.com/prod/wishlist`;
  const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';

  const requestData = {
    userId: window.userData.isLoggedIn.toString(),
    productId: window.productDetails.id.toString(),
    productUrl: window.productDetails.handle.toString(),
    action: 'REMOVE_FROM_WISHLIST'
  };

  fetch(apiUrl, {
    method: 'POST',
    headers: {
      'x-api-key': apiKey,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestData)
  })
    .then(response => response.json())
    .then(data => {
      if (data.success === true) {
        setWishlistHeartEmpty();
      }
    })
    .catch(error => console.error('Error:', error));
});
  
  // $(document).on('click', '.add_to_wishlist', function () {
  //   console.log('wishlist_added1');
  //   if(window.userData.customer){
  //     const apiUrl = `https://ux6g55bd4a.execute-api.ap-south-1.amazonaws.com/prod/wishlist`;
  //     const apiKey = 'KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q';
  
  //     const requestData = {
  //       userId: window.userData.isLoggedIn.toString(),
  //       productId: window.productDetails.id.toString(),
  //       productUrl: window.productDetails.handle.toString(),
  //       productType: window.productDetails.type.toString(),
  //       productAvailability: window.productDetails.available.toString(),
  //       productPrice: window.productDetails.price.toString(),
  //       variantId: '',
  //       action: 'ADD_TO_WISHLIST',
  //     };
  
  //     fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'x-api-key': apiKey,
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(requestData)
  //     })
  //     .then(response => response.json())
  //     .then(data => { 
  //       $("#pdpwishlist svg circle").css("fill", "#1a2b58");
  //       $("#pdpwishlist svg path").css("fill", "#FFF");
  //     })
  //     .catch(error => console.error("Wishlist API Error:", error));
  
  //   }else{
  //     let wishlist = getCookie('wishlist') || [];
  
  //     wishlist.push({
  //       producthref: window.location.href,
  //       productId: window.productDetails.id.toString(),
  //       productUrl: window.productDetails.handle.toString(),
  //       productType: window.productDetails.type.toString(),
  //       productAvailability: window.productDetails.available.toString(),
  //       productPrice: window.productDetails.price.toString(),
  //       variantId: '',
  //       action: 'ADD_TO_WISHLIST',
  //     });
  
  //     setCookie('wishlist', wishlist, 10);
  //     window.location.href = "/account/login";
  //   }
  // });